import LiberarAvisosComponent from "@/views/avisos/LiberarAvisos.vue";
import ConsultarAvisos from "@/views/mural-avisos/ConsultarAviso.vue";
import ListarAvisos from "@/views/cadastro-avisos/ListarAvisos.vue";
import DetalhesAviso from "@/views/cadastro-avisos/DetalhesAviso.vue";
import CriarAviso from "@/views/cadastro-avisos/CriarAviso.vue";
import EditarAviso from "@/views/cadastro-avisos/EditarAviso.vue";

const avisosRotas = [
  {
    path: "/mural-avisos",
    name: "mural-avisos",
    component: ConsultarAvisos,
  },
  {
    path: "/mural-avisos/manifestacoes",
    name: "mural-avisos--manifestacoes",
    component: () => import("@/views/administracao/ouvidoria/ConsultarManifestacoes.vue"),
    props: {
      somenteVisualizacao: true,
      cpfFixoUsuarioLogado: true,
    },
  },
  {
    path: "/mural-avisos/manifestacoes/:idManifestacao",
    name: "mural-avisos--visualiza-manifestacao",
    component: () => import("@/views/administracao/ouvidoria/VisualizaManifestacao.vue"),
    props: true,
  },
  {
    path: "/avisos/cadastro",
    name: "seguranca-administracao--cadastro-avisos",
    component: ListarAvisos,
  },
  {
    path: "/avisos/criar",
    name: "seguranca-administracao--avisos--criar",
    component: CriarAviso,
  },
  {
    path: "/avisos/editar/:idAviso",
    name: "seguranca-administracao--avisos--editar",
    component: EditarAviso,
    props: true,
  },
  {
    path: "/avisos/analise",
    name: "seguranca-administracao--analise-avisos",
    component: LiberarAvisosComponent,
  },
  {
    path: "/avisos/:idAviso",
    name: "seguranca-administracao--avisos",
    component: DetalhesAviso,
    props: true,
  },
];

export { avisosRotas };
